// extracted by mini-css-extract-plugin
export default {"CharacterCount":"wORtpZnA"};